import Vue from 'vue'
import App from './App.vue'

import VueMaterial from 'vue-material'

Vue.use(VueMaterial);

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

Vue.config.productionTip = false;
Vue.prototype.$isMobile = function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

import {createProvider} from './vue-apollo'

new Vue({
    apolloProvider: createProvider(),
    render: h => h(App)
}).$mount('#app');